/* tslint:disable */

declare var Object: any;
export interface SfgisServiceInterface {
  "id"?: number;
}

export class SfgisService implements SfgisServiceInterface {
  "id": number;
  constructor(data?: SfgisServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SfgisService`.
   */
  public static getModelName() {
    return "SfgisService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SfgisService for dynamic purposes.
  **/
  public static factory(data: SfgisServiceInterface): SfgisService{
    return new SfgisService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SfgisService',
      plural: 'SfgisServices',
      path: 'SfgisServices',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SfgisService.ts